// ../utils/dist/index.js
function tinyassert(value, message) {
  if (value) {
    return;
  }
  if (message instanceof Error) {
    throw message;
  }
  throw new TinyAssertionError(message, tinyassert);
}
var TinyAssertionError = class extends Error {
  constructor(message, stackStartFunction) {
    super(message);
    if (stackStartFunction && "captureStackTrace" in Error) {
      Error.captureStackTrace(this, stackStartFunction);
    }
  }
};
var typedBoolean = Boolean;
function once(f) {
  let result;
  let called = false;
  function wrapper(...args) {
    if (!called) {
      result = f(...args);
      called = true;
    }
    return result;
  }
  return wrapper;
}

export {
  tinyassert,
  typedBoolean,
  once
};
